export enum UploadBoxStates {
  PreUpload = 'preupload',
  Uploading = 'upload',
  Uploaded = 'uploaded',
  UploadFailed = 'uploadfailed',
  InvalidFile = 'invalidfile'
}
